function resolveLogEndpoint() {
  if (typeof window === 'undefined') {
    return null
  }

  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:'
  const hostname = window.location.hostname || '127.0.0.1'
  const port = process.env.GATSBY_EVENT_LOG_PORT ?? '8889'

  return `${protocol}//${hostname}:${port}/event-log`
}

function postEventToLogFile(event) {
  const endpoint = resolveLogEndpoint()
  if (!endpoint) {
    return
  }

  const payload = JSON.stringify(event)

  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    const blob = new Blob([payload], { type: 'application/json' })
    navigator.sendBeacon(endpoint, blob)
    return
  }

  if (typeof fetch !== 'function') {
    return
  }

  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    mode: 'cors',
    keepalive: true,
  }).catch(() => {})
}

export function createLogHandler() {
  return {
    name: 'log',
    handle(event) {
      if (typeof console !== 'undefined' && typeof console.info === 'function') {
        console.info('[event-log]', event.name, {
          properties: event.properties,
          metadata: event.metadata,
        })
      }

      if (typeof window === 'undefined') {
        return
      }

      postEventToLogFile(event)
    },
  }
}
